import React, { Component } from "react";
import { Table, Button } from "semantic-ui-react";
import _ from "lodash";
import CaseComponent from "../common/CaseComponent";
import BusinessAdditionalContacts from "./Business/BusinessAdditionalContacts";
import BusinessAreaCompetitors from "./Business/BusinessAreaCompetitors";
import BusinessCreditCapacity from "./Business/BusinessCreditCapacity";
import BusinessCreditRatings from "./Business/BusinessCreditRatings";
import BusinessNearby from "./Business/BusinessNearby";
import BusinessProfile from "./Business/BusinessProfile";

class BusinessReport extends Component {
  constructor(props) {
    super(props);
    this.state = {
      rows: [],
    };
  }

  componentDidMount() {
    this.loadData(this.props);
  }

  componentWillReceiveProps(nextProps) {
    this.loadData(nextProps);
  }

  loadData = (props) => {
    const rows = [];
    if (props.reportData !== undefined) {
      const node = _.get(props.reportData, "corpReport.record[0]");
      const leftCols = [];
      const rightCols = [];
      leftCols.push(
        <BusinessProfile key={"BusinessProfile"} node={node} {...props} />
      );
      leftCols.push(
        <BusinessAdditionalContacts
          key={"BusinessAdditionalContacts"}
          node={node}
          {...props}
        />
      );
      leftCols.push(
        <BusinessNearby key={"BusinessNearby"} node={node} {...props} />
      );
      leftCols.push(
        <BusinessCreditCapacity
          key={"BusinessCreditCapacity"}
          node={node}
          {...props}
        />
      );

      rightCols.push(
        <BusinessCreditRatings
          key={"BusinessCreditRatings"}
          node={node}
          {...props}
        />
      );
      rightCols.push(
        <BusinessAreaCompetitors
          key={"BusinessAreaCompetitors"}
          node={node}
          {...props}
        />
      );
      rows.push(
        <Table.Row key={"Row_Business_Report"}>
          <Table.Cell>{leftCols}</Table.Cell>
          <Table.Cell colSpan={2}>{rightCols}</Table.Cell>
        </Table.Row>
      );
    } else {
      rows.push(
        <Table.Row key={`no_recs_row`}>
          <Table.Cell colSpan={2}>No Records found</Table.Cell>
        </Table.Row>
      );
    }
    this.setState({ rows });
  };

  render() {
    return (
      <div id={`report`}>
        <Table stackable key={"Business_Header_Name"}>
          <Table.Body>
            <Table.Row>
              <Table.Cell>
                {this.props.reportData && (
                  <div>
                    <h1>
                      {_.get(
                        this.props.reportData,
                        "corpReport.record[0].companyName[0]._",
                        ""
                      )}
                    </h1>
                    <p>
                      Business Report Prepared{" "}
                      {_.get(
                        this.props.reportData,
                        "corpReport[0].log[0].actDate[0]._",
                        ""
                      )}
                    </p>
                  </div>
                )}
              </Table.Cell>
              <Table.Cell>
                <div className={`no-print`}>
                  <Button
                    className={"margin-left-10"}
                    onClick={() => this.props.printContent("report", `Report`)}
                  >
                    Print
                  </Button>
                </div>
              </Table.Cell>
              <Table.Cell>
                <div className={`no-print`}>
                  <CaseComponent
                    {...this.props}
                    actId={_.get(
                      this.props.reportData,
                      `${Object.keys(this.props.reportData)[0]}.log[0].actID[0]`
                    )}
                    compType={"report"}
                  />
                </div>
              </Table.Cell>
            </Table.Row>
            {this.state.rows}
          </Table.Body>
        </Table>
      </div>
    );
  }
}

export default BusinessReport;



// WEBPACK FOOTER //
// ./src/components/reports/BusinessReport.js